export default __webpack_public_path__ + "static/media/online.8721a76d.png";